import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { players } from 'redux/modules'
import Loader from './Loader'

const PlayersLoader = ({
  teamId,
  fetchTeamPlayers,
  children,
  ...restProps
}) => {
  const fetchMethod = () => fetchTeamPlayers(teamId)
  const triggers = [teamId]

  return (
    <Loader fetchMethod={fetchMethod} triggers={triggers} {...restProps}>
      {children}
    </Loader>
  )
}
PlayersLoader.defaultProps = {
  children: null,
}

PlayersLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  teamId: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]).isRequired,
  fetchTeamPlayers: PropTypes.func.isRequired,
}

export default connect(
  ({ team }) => ({
    teamId: team.uuid,
  }),
  { fetchTeamPlayers: players.fetchTeamPlayers }
)(PlayersLoader)
